import { render, staticRenderFns } from "./SetupPayment.vue?vue&type=template&id=210c6b90&scoped=true"
import script from "./SetupPayment.vue?vue&type=script&lang=js"
export * from "./SetupPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c6b90",
  null
  
)

export default component.exports